import React from "react";
import { Badge } from "../ui/badge";

const CONFIG = {
  draft:     { label: "Draft",     className: "bg-muted/40 text-muted-foreground border-border/60" },
  active:    { label: "Active",    className: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  paused:    { label: "Paused",    className: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  completed: { label: "Completed", className: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  archived:  { label: "Archived",  className: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30" },
};

export default function CampaignStatusPill({ status = "active", size = "sm", testId }) {
  const cfg = CONFIG[status] || CONFIG.draft;
  const padding = size === "xs" ? "px-2 py-0" : "px-2.5 py-0.5";
  return (
    <Badge
      variant="outline"
      className={`font-sans-ui text-[10px] uppercase tracking-widest border ${padding} ${cfg.className}`}
      data-testid={testId}
    >
      {cfg.label}
    </Badge>
  );
}
